export enum ExternalServicesKey {
  Microsoft = 'MICROSOFT',
  Dropbox = 'DROPBOX',
  DropboxSign = 'HELLOSIGN',
  Acronis = 'ACRONIS',
  Eset = 'ESET',
  Exclaimer = 'EXCLAIMER',
  KeepIt = 'KEEPIT',
  ImpossibleCloud = 'IMPOSSIBLECLOUD',
  Twingate = 'TWINGATE',
  Adobe = "ADOBE",
}

export interface IExternalServices {
  [key: string]: string;
}
